module.exports = __webpack_public_path__ + "img/S0.fe247436.png";